import { render, staticRenderFns } from "./footer.html?vue&type=template&id=268bf318&scoped=true&"
import script from "./footer.js?vue&type=script&lang=js&"
export * from "./footer.js?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=268bf318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268bf318",
  null
  
)

export default component.exports